<template>
    <div>
        <v-btn color="green" text @click="showAddStandalonePhone = true">Add Phone</v-btn>
        <v-dialog v-model="showAddStandalonePhone">
            <v-card>
                <v-card-title class="primary--text pr-4">
                    Add a Phone
                    <v-spacer />
                    <v-btn icon color="grey" text @click="showAddStandalonePhone = false"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="phone.phoneNumber" placeholder="Phone Number" label="Phone Number" outlined></v-text-field>
                    <v-text-field v-model="phone.imei" placeholder="IMEI" label="IMEI" outlined></v-text-field>
                    <v-text-field v-model="phone.msisdn" placeholder="MSISDN" label="MSISDN" outlined></v-text-field>
                    <v-btn color="green" text @click="addPhone()">Save</v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <draggable v-model="mobilePhones">
            <transition-group>
                <div class='draggable-div' v-for="element in mobilePhones" :key="element.phoneNumber + 'phone'">
                    <v-row>
                        <v-col cols='6'>
                            {{element.phoneNumber}},{{element.imei}},{{element.msisdn}}
                        </v-col>
                    </v-row>
                </div>
            </transition-group>
        </draggable>
    </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
    props:['mobilePhones'],
    data(){
        return {
            showAddStandalonePhone : false,
            phone:{phoneNumber:'', imei:'', msisdn:''},
        }
    },
    components:{draggable},
    methods:{
        addPhone(){
            if(this.mobilePhones === undefined || !Array.isArray(this.mobilePhones)) {
                this.mobilePhones = []
            }
            this.mobilePhones.push(this.phone)
            this.showAddStandalonePhone = false; //hide the dialog in the end
        }
    }
}
</script>